import { trackEvent } from '../../../helpers/analytics/trackEvent';
import { trackNavigationBetweenWaters } from '../../../helpers/analytics/trackNavigationBetweenWaters';
import { logger } from '../../../helpers/logging';
import { HandleMapIconClick } from '../types/types';

import { getFishingWaterEventType } from './getFishingWaterEventType';

export const handleWaterIconClick: HandleMapIconClick = ({ layerId, event, setSelectedIcon }) => {
  logger.debug('Water icon click');

  const latitude = event.lngLat.lat;
  const longitude = event.lngLat.lng;
  const waterId = event.features![0].properties!.external_id;
  const fishingWaterEventType = getFishingWaterEventType(layerId);

  if (!waterId) {
    throw new Error(
      `No Id was found when clicking that icon - Lat: ${latitude}, Lng: ${longitude}`,
    );
  }

  if (typeof waterId !== 'string') {
    throw new Error(`The provided externalId was not a string`);
  }

  trackNavigationBetweenWaters('map');
  void trackEvent({
    name: 'mykiss_explore_marker_clicked',
    properties: {
      type: fishingWaterEventType,
    },
  });

  setSelectedIcon({
    drawerViewId: waterId,
    drawerView: 'fishing-water',
    latitude,
    longitude,
  });
};
